import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import Gallery from './Gallery.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "gallery"
    }}>{`Gallery`}</h1>
    <p>{`These are the examples of components built with Encodable.`}</p>

    <Gallery mdxType="Gallery" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      